import React, { Component } from 'react';
import Link from 'gatsby-link';
import LogoSVG from './LogoSVG';
import style from './Logo.module.scss';

import { TweenLite } from 'gsap';

class Logo extends Component {
  render() {
    return (
      <Link to="/" className={`logo ${style.logo}`}>
        <LogoSVG {...this.props} />
      </Link>
    );
  }
}

export default Logo;



// WEBPACK FOOTER //
// ./src/components/global/Logo.js